import * as React from 'react'
import styled from 'styled-components'
import { colors } from '../../styleConstants'

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const TextArea = React.forwardRef<HTMLTextAreaElement, Props>(({ children, ...props }, ref) => {
  return <DesignedTextArea ref={ref} {...props} />
})

const DesignedTextArea = styled.textarea`
  appearance: none;
  outline: 0;
  padding: 0.5em;
  width: 100%;
  height: 5em;
  background: ${colors.white};
  border: 1px solid ${colors.gray300};
  border-radius: 4px;
  color: ${colors.gray800};

  &:active,
  &:focus {
    border: 1px solid ${colors.secondary};
  }

  &:empty:required {
    border: 1px solid ${colors.gray300};
  }

  &:invalid {
    border: 1px solid ${colors.error};
  }
`
